var exports = {
  "Q": "xfb577c5e--2b1236--content",
};

module.exports = exports;
